import React from 'react';
import { SpacerBlock as SpacerBlockType } from './types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';

interface SpacerBlockProps {
  block: SpacerBlockType;
  onChange: (block: SpacerBlockType) => void;
  isEditing?: boolean;
}

export const SpacerBlockDisplay: React.FC<{ block: SpacerBlockType }> = ({ block }) => {
  return (
    <div 
      className="w-full bg-muted/30 border-y border-dashed border-muted-foreground/20 flex items-center justify-center"
      style={{ height: block.height }}
    >
      <span className="text-[10px] text-muted-foreground/50">{block.height}px</span>
    </div>
  );
};

export const SpacerBlockEditor: React.FC<SpacerBlockProps> = ({ block, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Height (px)</Label>
        <div className="flex items-center gap-4">
          <Slider
            value={[block.height]}
            onValueChange={([value]) => onChange({ ...block, height: value })}
            min={4}
            max={64}
            step={4}
            className="flex-1"
          />
          <Input
            type="number"
            value={block.height}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '') onChange({ ...block, height: '' as any });
              else { const num = parseInt(val); if (!isNaN(num)) onChange({ ...block, height: num }); }
            }}
            onBlur={(e) => {
              const num = parseInt(e.target.value);
              if (isNaN(num) || num < 1) onChange({ ...block, height: 16 });
            }}
            className="w-20"
          />
        </div>
      </div>

      <div className="flex gap-2">
        {[4, 8, 12, 16, 24, 32].map((preset) => (
          <button
            key={preset}
            onClick={() => onChange({ ...block, height: preset })}
            className={`px-3 py-1 rounded text-xs border transition-colors ${
              block.height === preset 
                ? 'bg-primary text-primary-foreground border-primary' 
                : 'hover:bg-muted border-border'
            }`}
          >
            {preset}px
          </button>
        ))}
      </div>
    </div>
  );
};
